import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Loader2, Users, User, UserPlus } from 'lucide-react';

const CoachClientsTab = ({ 
  clients, 
  loading, 
  onUpdateStatus,
  onAssignClient 
}) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-forest" />
      </div>
    );
  }

  const getStatusBadge = (status) => {
    const styles = {
      active: 'bg-green-100 text-green-700',
      complete: 'bg-blue-100 text-blue-700',
      inactive: 'bg-gray-100 text-gray-600',
      paused: 'bg-amber-100 text-amber-700',
      cancelled: 'bg-red-100 text-red-700'
    };
    return styles[status] || 'bg-gray-100 text-gray-700';
  };

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5 text-forest" />
            Clients ({clients.length})
          </CardTitle>
          <CardDescription>Manage clients assigned to this coach</CardDescription>
        </div>
        {onAssignClient && (
          <Button 
            onClick={onAssignClient}
            className="bg-forest hover:bg-forest/90"
          >
            <UserPlus className="h-4 w-4 mr-2" /> Assign Client
          </Button>
        )}
      </CardHeader>
      <CardContent>
        {clients.length === 0 ? (
          <p className="text-gray-500 text-center py-8">No clients assigned yet</p>
        ) : (
          <div className="space-y-3">
            {clients.map(client => (
              <div 
                key={client.id}
                className="flex items-center justify-between p-4 border rounded-lg hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center">
                    <User className="h-5 w-5 text-gold" />
                  </div>
                  <div>
                    <p className="font-medium">{client.user?.full_name || client.full_name || 'Unknown'}</p>
                    <p className="text-sm text-gray-500">{client.user?.email || client.email}</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <Badge className={getStatusBadge(client.status)}>
                    {client.status}
                  </Badge>
                  {onUpdateStatus && (
                    <Select 
                      value={client.status}
                      onValueChange={(value) => onUpdateStatus(client.user_id || client.id, value)}
                    >
                      <SelectTrigger className="w-32">
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="active">Active</SelectItem>
                        <SelectItem value="inactive">Inactive</SelectItem>
                        <SelectItem value="complete">Complete</SelectItem>
                      </SelectContent>
                    </Select>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CoachClientsTab;
